/* eslint-disable */
/* Source: https://github.com/KoderLabs/ng2-device-detector --> MODULE NOT READY FOR SERVER RENDERING */

import {Injectable} from '@angular/core';
import * as Constants from './ng2-device.constants';
import {ReTree} from './retree.service';
import {DeviceInfoDto} from '../dto/DeviceInfoDto';

type DeviceProperty = 'os' | 'browser' | 'device' | 'os_version';

@Injectable()
export class Ng2DeviceService {
    public ua = '';
    public userAgent = '';
    public os = '';
    public browser = '';
    public device = '';
    public os_version = '';
    public browser_version = '';

    public getDeviceInfo(): DeviceInfoDto {
        this.ua = window.navigator.userAgent;
        this._setDeviceInfo();

        return {
            userAgent: this.userAgent,
            os: this.os,
            browser: this.browser,
            device: this.device,
            os_version: this.os_version,
            browser_version: this.browser_version,
        };
    }

    private _setDeviceInfo(): void {
        const reTree = new ReTree();
        const ua = this.ua;
        this.userAgent = ua;
        const mappings: {const: 'OS' | 'BROWSERS' | 'DEVICES' | 'OS_VERSIONS', prop: DeviceProperty}[] = [
            {const: 'OS', prop: 'os'},
            {const: 'BROWSERS', prop: 'browser'},
            {const: 'DEVICES', prop: 'device'},
            {const: 'OS_VERSIONS', prop: 'os_version'},
        ];

        const matches: Record<DeviceProperty, Record<string, boolean>> = {os: {}, browser: {}, device: {}, os_version: {}};
        mappings.forEach((mapping) => {
            matches[mapping.prop] = Object.keys(Constants[mapping.const]).reduce((obj: any, item: any) => {
                obj[Constants[mapping.const][item]] = reTree.test(ua, Constants[`${mapping.const}_RE`][item]);
                return obj;
            }, {});
        });

        mappings.forEach((mapping) => {
            this[mapping.prop] = Object.keys(Constants[mapping.const])
                .map((key) => {
                    return Constants[mapping.const][key];
                }).reduce((previousValue, currentValue) => {
                    return (previousValue === Constants[mapping.const].UNKNOWN && matches[mapping.prop][currentValue])
                        ? currentValue : previousValue;
                }, Constants[mapping.const].UNKNOWN);
        });

        this.browser_version = '0';
        if (this.browser !== Constants.BROWSERS.UNKNOWN) {
            const re = Constants.BROWSER_VERSIONS_RE[this.browser];
            const res = reTree.exec(ua, re);
            if (res) {
                this.browser_version = res[1];
            }
        }
    }
}
